import { useGetEntities } from '@abaninja/util-store';

import { getConnections } from '../connections';

export const useConnectionsStore = () => useGetEntities(getConnections);
